export const products = [
    // --- 1. Maintenance-Spare-Parts ---
    {
        id: 1,
        name: "Bando HP-STS S8M 888 Industrial Synchronous Timing Belt",
        type: "Maintenance-Spare-Parts",
        price: "$35.00",
        description: "High-torque, durable S8M timing belt for precise industrial synchronization.",
        large_description:
            <>
                <p>The Bando HP-STS (High Performance Super Torque System) is a premium-grade timing belt designed for high-torque applications requiring precise synchronization and durability. Featuring a specialized S8M curvilinear tooth profile, this belt minimizes stress concentration at the tooth roots, ensuring a smoother engagement with the pulleys and a significantly longer service life compared to standard belts.</p>
                <p>Key Features
                    <ul style={{ marginLeft: '30px' }}>
                        <li>High Torque Transmission: Engineered with high-modulus tensile cords to handle heavy loads with minimal stretch.</li>
                        <li>Precision Profile: The S8M pitch (8mm) provides quiet operation and high positional accuracy, making it ideal for industrial machinery and robotics.</li>
                        <li>Durable Construction: Built with oil and heat-resistant synthetic rubber to withstand harsh industrial environments.</li>
                        <li>Low Maintenance: Designed for "fit and forget" reliability, reducing downtime caused by belt re-tensioning.</li>
                    </ul>
                </p>
                <p>Technical Specifications
                    <ul style={{ marginLeft: '30px' }}>
                        <li>Brand: Bando</li>
                        <li>Series: HP-STS (High Performance)</li>
                        <li>Tooth Profile: S8M (8mm Pitch)</li>
                        <li>Length: 888 mm</li>
                        <li>Material: High-grade Chloroprene rubber with Fiberglass cords</li>
                    </ul>
                </p>
            </>,
        certification: "https://via.placeholder.com/100x100?text=NIST+Cert",
        images: {
            main: "/Images/products/maintenance-spare-parts/6.png",
            thumbnails: [
                "/Images/products/maintenance-spare-parts/6.png",
                "/Images/products/maintenance-spare-parts/5.png",
                "/Images/products/maintenance-spare-parts/7.png"
            ]
        }
    },
    {
        id: 2,
        name: "Radial Deep Groove Ball Bearings",
        type: "Maintenance-Spare-Parts",
        price: "$35.00",
        description: "Versatile, high-speed bearings for multi-directional loads and low-friction efficiency.",
        large_description:
            <>
                <p>Deep groove ball bearings are the most common and versatile type of rolling-element bearings used in modern industry. Featuring deep, uninterrupted raceway grooves, these bearings are engineered to accommodate radial and axial loads in both directions. Their simple, non-separable design is optimized for low friction, high rotational accuracy, and quiet operation, making them the standard choice for high-speed machinery.</p>
                <p>
                    Key Features
                    <ul style={{ marginLeft: '30px' }}>
                        <li>High-Speed Capability: Optimized internal geometry and smooth raceway finishes allow for exceptionally high RPMs with minimal heat generation.</li>
                        <li>Maintenance-Free Operation: Most shielded (ZZ) or sealed (2RS) variants are pre-lubricated with high-grade industrial grease, designed for "fit and forget" long-term service.</li>
                        <li>Low Friction & Vibration: Precision-ground steel balls and honed raceways ensure low frictional torque, which enhances energy efficiency and reduces noise.</li>
                        <li>Multi-Directional Load Support: Capable of handling significant radial loads and moderate axial (thrust) loads simultaneously, providing flexibility in design and application.</li>
                    </ul>
                </p>
                <p>
                    Technical Specifications
                    <ul style={{ marginLeft: '30px' }}>
                        <li>Type: Single Row Deep Groove Ball Bearing (ISO 15:2017)</li>
                        <li>Material: High-Carbon Chromium Steel (GCr15/52100)</li>
                        <li>Tolerance Class: ABEC-1 / P0 (Standard) or ABEC-3 / P6 (Precision)</li>
                        <li>Internal Clearance: CN (Normal) or C3 (Loose fit for high heat)</li>
                        <li>Standard Temperature Range: -30°C to +120°C (depending on lubricant)</li>
                    </ul>
                </p>
            </>,
        certification: "https://via.placeholder.com/100x100?text=NIST+Cert",
        images: {
            main: "/Images/products/maintenance-spare-parts/2.png",
            thumbnails: [
                "/Images/products/maintenance-spare-parts/3.png",
                "/Images/products/maintenance-spare-parts/4.png",
                "/Images/products/maintenance-spare-parts/5.png"
            ]
        }
    },
    {
        id: 3,
        name: "High-Efficiency Pulse-Jet Dust Collector Filter Bags",
        type: "Maintenance-Spare-Parts",
        price: "$35.00",
        description: "High-efficiency industrial filter bags for diverse systems and temperatures.",
        large_description:
            <>
                <p>Upgrade your air filtration system with our industrial-grade dust collector filter bags, engineered for maximum particulate capture and long-term durability. Designed for pulse-jet, shaker, and reverse-air baghouse systems, these bags maintain high airflow while meeting strict emission standards.</p>
                <p>​Superior Filtration: Available in [1 to 50] micron ratings to capture fine dust, smoke, and industrial fumes.</p>
                <p>​Engineered Media: Choose from Needle-Punched Polyester for general use, Aramid (Nomex®) for high-temp applications (up to 400°F), or PTFE-coated media for superior cake release and chemical resistance.
                    Precision Fit: Features [Snap Band/Steel Ring/Cuff] tops for a leak-proof seal, preventing dust bypass and protecting your downstream equipment.
                    Extended Service Life: Treated with [singed/glazed] finishes to facilitate easy dust cake removal and reduce cleaning frequency.</p>
            </>,
        certification: "https://via.placeholder.com/100x100?text=NIST+Cert",
        images: {
            main: "/Images/products/maintenance-spare-parts/9.png",
            thumbnails: [
                "/Images/products/maintenance-spare-parts/9.png",
                "/Images/products/maintenance-spare-parts/10.png",
                "/Images/products/maintenance-spare-parts/9.png"
            ]
        }
    },
    {
        id: 4,
        name: "Heavy-Duty Multi-Ply Rubber Conveyor Belt",
        type: "Maintenance-Spare-Parts",
        price: "$35.00",
        description: "Durable, multi-ply conveyor belts for extreme bulk material handling.",
        large_description:
            <>
                <p>Designed for the most demanding bulk material handling environments, these heavy-duty rubber conveyor belts are engineered to withstand extreme conditions in mining, construction, and agriculture. The multi-ply carcass construction provides exceptional load-bearing strength, while the high-grade rubber covers offer superior resistance to abrasion, impact, and chemical exposure.</p>
                <p>Key Features</p>
                <p>​Multi-Ply Construction: Layers of high-strength polyester or nylon fabric (EP/NN) are sandwiched between rubber skim coats for maximum impact absorption and tensile strength.​Pattern Options: Available in Smooth surfaces for horizontal transport and Chevron (V-cleat) patterns for high-angle inclines up to 45^\circ, preventing material rollback.</p>
                <p>Specialized Grade Compounds: Available in heat-resistant, oil-resistant, and fire-retardant grades to suit specific industrial requirements. Longevity: Features "Superior Abrasion" (SAR) covers designed to handle sharp or rough materials like coal, gravel, and ore with minimal wear.</p>
            </>,
        certification: "https://via.placeholder.com/100x100?text=NIST+Cert",
        images: {
            main: "/Images/products/maintenance-spare-parts/11.png",
            thumbnails: [
                "/Images/products/maintenance-spare-parts/11.png",
                "/Images/products/maintenance-spare-parts/12.png",
                "/Images/products/maintenance-spare-parts/12.png"
            ]
        }
    },
    {
        id: 5,
        name: "Single Spring Mechanical Seal (with Stationary Seat)",
        type: "Maintenance-Spare-Parts",
        price: "$35.00",
        description: "Mechanical seal using spring pressure to prevent fluid leakage.",
        large_description:
            <>
                <p>This is a common industrial mechanical seal used to prevent fluid leakage in rotating equipment like centrifugal pumps, compressors, and mixers. The assembly consists of two primary parts:
                    The Rotary Part (Head): Features a single helical coil spring that maintains constant pressure on the seal faces, ensuring they stay in contact even during shaft misalignment or axial movement.
                    The Stationary Part (Seat): The separate ring (shown on the left in the image) that is fixed into the pump housing.</p>
            </>,
        certification: "https://via.placeholder.com/100x100?text=NIST+Cert",
        images: {
            main: "/Images/products/maintenance-spare-parts/13.jpeg",
            thumbnails: [
                "/Images/products/maintenance-spare-parts/13.jpeg",
                "/Images/products/maintenance-spare-parts/14.jpeg",
                "/Images/products/maintenance-spare-parts/13.jpeg"
            ]
        }
    },

    // --- 2. Electrical-&-Controls ---
    {
        id: 10,
        name: "ACB, MCCB, and MCBs",
        type: "Electrical-&-Controls",
        price: "$35.00",
        description: "Comprehensive circuit breakers for commercial and industrial electrical protection.",
        large_description:
            <>
                <p>ACB, Air Circuit Breaker, a type of electronic equipment used for the protection of electric circuits from short circuits or overcurrent. The ACB operates at atmospheric pressure in air. ACB is used in the switching mechanism and protection of the electrical system.</p>
                <p>MCCB, Molded Case Circuit Breaker, used at the load side of the circuit in order to break the circuit from load side in case of any fault which can cause damage to the circuit.</p>
                <p>MCB, Miniature Circuit Breaker, an electromagnetic device that carries a complete molded insulating material. The primary function of this device is to switch the circuit. This means to automatically open the circuit (which has been connected to it) when the current passing through the circuit goes beyond a set value or limit. The device can be manually switched ON or OFF just like normal switches whenever necessary.</p>
                <p>We are distributing a comprehensive range circuit breakers to serve commercial and industrial needs. Our reputable brand partners include ABB, Fuji Electric, Schneider Electric, and more.</p>
            </>,
        certification: "https://via.placeholder.com/100x100?text=NIST+Cert",
        images: {
            main: "/Images/products/electrical-and-controls/1.png",
            thumbnails: [
                "/Images/products/electrical-and-controls/1.png",
                "/Images/products/electrical-and-controls/1.png",
                "/Images/products/electrical-and-controls/1.png"
            ]
        }
    },
    {
        id: 11,
        name: "RCCB and RCBOs",
        type: "Electrical-&-Controls",
        price: "$35.00",
        description: "Dedicated shock protection (RCCB) vs. all-in-one circuit safety (RCBO).",
        large_description:
            <>
                <p>RCCB stands for Residual Circuit Current Breaker. It is an electrical wiring device whose function is to disconnect the circuit when it detects currents leaking to the earth wire. It also gives protection against electric shock or electrocution caused by direct contacts.</p>
                <p>RCBO stands for Residual Circuit Current Breaker with Overload Protection. It mainly protects against earth fault, overloads, and short circuit currents.</p>
                <p>Our reputable brand partners include ABB, Fuji Electric, Schneider Electric, and more.</p>
            </>,
        certification: "https://via.placeholder.com/100x100?text=NIST+Cert",
        images: {
            main: "/Images/products/electrical-and-controls/2.png",
            thumbnails: [
                "/Images/products/electrical-and-controls/2.png",
                "/Images/products/electrical-and-controls/2.png",
                "/Images/products/electrical-and-controls/2.png"
            ]
        }
    },
    {
        id: 12,
        name: "Auto Recloser",
        type: "Electrical-&-Controls",
        price: "$35.00",
        description: "Smart high-voltage switches that automatically restore power after temporary faults.",
        large_description:
            <>
                <p>A recloser is an automatic, high-voltage electric switch. Like a circuit breaker on household electric lines, it shuts off electric power when trouble occurs, such as a short circuit. Where a household circuit breaker remains shut off until it is manually reset, a recloser automatically tests the electrical line to determine whether the trouble has been removed. If the problem was only temporary, the recloser automatically resets itself and restores the electric power.</p>
                <p>Our reputable brand partners include ABB, Schneider Electric, and more.</p>
            </>,
        certification: "https://via.placeholder.com/100x100?text=NIST+Cert",
        images: {
            main: "/Images/products/electrical-and-controls/3.png",
            thumbnails: [
                "/Images/products/electrical-and-controls/3.png",
                "/Images/products/electrical-and-controls/3.png",
                "/Images/products/electrical-and-controls/3.png"
            ]
        }
    },
    {
        id: 13,
        name: "Thermal Magnetic Circuit Breakers",
        type: "Electrical-&-Controls",
        price: "$35.00",
        description: "Dual-action protection against slow overloads and instant short circuits.",
        large_description:
            <>
                <p>Thermal-magnetic protection provides the following features for general-purpose applications:</p>
                <ul style={{ marginLeft: '30px' }}>
                    <li>Thermal protection against overload, with fixed threshold In.</li>
                    <li>Instantaneous protection against short circuits, with fixed threshold Ii.</li>
                </ul>
                <p>Our reputable brand partners include ABB, Fuji Electric, Schneider Electric, and more.</p>
            </>,
        certification: "https://via.placeholder.com/100x100?text=NIST+Cert",
        images: {
            main: "/Images/products/electrical-and-controls/4.png",
            thumbnails: [
                "/Images/products/electrical-and-controls/4.png",
                "/Images/products/electrical-and-controls/4.png",
                "/Images/products/electrical-and-controls/4.png"
            ]
        }
    },
    {
        id: 14,
        name: "Motor Protection Circuit Breakers",
        type: "Electrical-&-Controls",
        price: "$35.00",
        description: "Specialized circuit breakers for total motor safety and fault prevention.",
        large_description:
            <>
                <p>Motor protection is used to prevent damage to an electrical motor and reduce the incidence of problems such as internal faults and abnormal conditions. The type of motor protection you choose depends on the size of motor you need and the voltage level required.</p>
                <p>A motor protection circuit breaker prevents wires and motors from damage by reducing the current flow in a circuit when the power running through an electric circuit exceeds its standard or specified limitations.</p>
                <p>Our reputable brand partners include ABB, Fuji Electric, Schneider Electric, and more.</p>
            </>,
        certification: "https://via.placeholder.com/100x100?text=NIST+Cert",
        images: {
            main: "/Images/products/electrical-and-controls/5.png",
            thumbnails: [
                "/Images/products/electrical-and-controls/5.png",
                "/Images/products/electrical-and-controls/5.png",
                "/Images/products/electrical-and-controls/5.png"
            ]
        }
    },
    {
        id: 15,
        name: "Industrial and Domestic Plugs and Sockets",
        type: "Electrical-&-Controls",
        price: "$35.00",
        description: "Robust connectivity and internal lightning defense for critical power systems.",
        large_description:
            <>
                <p>Surge protection refers to protecting systems and electrical devices against excessively high voltage peaks caused by switching operations and lightning strikes. An effective lightning protection strategy combines internal and external lightning protection. Protect the power supplies, data, and signals in your system. Use the reliable surge protection solutions available in our various product ranges as part of your internal lightning protection strategy.</p>
                <p>Our reputable brand partners include ABB, Schneider Electric, and more. Don’t hesitate to get in touch with us to check for stock availability.</p>
            </>,
        certification: "https://via.placeholder.com/100x100?text=NIST+Cert",
        images: {
            main: "/Images/products/electrical-and-controls/6.png",
            thumbnails: [
                "/Images/products/electrical-and-controls/6.png",
                "/Images/products/electrical-and-controls/6.png",
                "/Images/products/electrical-and-controls/6.png"
            ]
        }
    },
    {
        id: 16,
        name: "Arc Flash Safety Devices",
        type: "Electrical-&-Controls",
        price: "$35.00",
        description: "Fast-acting optical systems for instantaneous explosion and fire prevention.",
        large_description:
            <>
                <p>An arc flash is a high-temperature explosion caused by unwanted electric discharge through the air from one voltage phase to another or to ground. Arc flash accidents in electrical installations are severe, resulting in damages, fire, and injuries. Ensure electrical safety at your workplace with our arc fault protection solutions.</p>
                <p>We distribute ABB arc flash safety devices. Contact us to check for stock availability.</p>
            </>,
        certification: "https://via.placeholder.com/100x100?text=NIST+Cert",
        images: {
            main: "/Images/products/electrical-and-controls/7.png",
            thumbnails: [
                "/Images/products/electrical-and-controls/7.png",
                "/Images/products/electrical-and-controls/7.png",
                "/Images/products/electrical-and-controls/7.png"
            ]
        }
    },
    {
        id: 17,
        name: "Power System Monitoring and Control",
        type: "Electrical-&-Controls",
        price: "$35.00",
        description: "Comprehensive real-time monitoring and smart grid control for power stability.",
        large_description:
            <>
                <p>Power System Monitoring and Control presents a comprehensive overview of the basic principles and key technologies for the monitoring, protection, and control of contemporary wide-area power systems. A variety of topical issues are addressed, including renewable energy sources, smart grids, wide area stabilizing, coordinated voltage regulation, and angle oscillation damping—as well as the advantages of phasor measurement units (PMUs) and global positioning system (GPS) time signal. Our reputable brand partners include ABB, Omron, Schneider Electric, and more.</p>
            </>,
        certification: "https://via.placeholder.com/100x100?text=NIST+Cert",
        images: {
            main: "/Images/products/electrical-and-controls/8.png",
            thumbnails: [
                "/Images/products/electrical-and-controls/8.png",
                "/Images/products/electrical-and-controls/8.png",
                "/Images/products/electrical-and-controls/8.png"
            ]
        }
    },
    {
        id: 18,
        name: "Automatic Transfer Switches",
        type: "Electrical-&-Controls",
        price: "$35.00",
        description: "Intelligent switches for seamless power transition between two sources.",
        large_description:
            <>
                <p>The principal purpose of an Automatic Transfer Switches (ATS) is to ensure the continuous delivery of electrical power from one of two power sources to a connected load circuit (electrical equipment – lights, motors, computers, etc.).</p>
                <p>Our reputable brand partners include ABB, Schneider Electric, Socomec, and more.</p>
            </>,
        certification: "https://via.placeholder.com/100x100?text=NIST+Cert",
        images: {
            main: "/Images/products/electrical-and-controls/9.png",
            thumbnails: [
                "/Images/products/electrical-and-controls/9.png",
                "/Images/products/electrical-and-controls/9.png",
                "/Images/products/electrical-and-controls/9.png"
            ]
        }
    },
    {
        id: 19,
        name: "Switch Disconnectors",
        type: "Electrical-&-Controls",
        price: "$35.00",
        description: "Reliable manual isolation for safe equipment maintenance and protection.",
        large_description:
            <>
                <p>Switch disconnectors provides reliable isolation switching and fuse circuit protection with switching for general and industrial applications, including switchboards, and motor controls centres.</p>
                <p>Our reputable brand partners include ABB, Schneider Electric, and more.</p>
            </>,
        certification: "https://via.placeholder.com/100x100?text=NIST+Cert",
        images: {
            main: "/Images/products/electrical-and-controls/10.png",
            thumbnails: [
                "/Images/products/electrical-and-controls/10.png",
                "/Images/products/electrical-and-controls/10.png",
                "/Images/products/electrical-and-controls/10.png"
            ]
        }
    },
    {
        id: 20,
        name: "Fuses and Fuse Holders HV & LV",
        type: "Electrical-&-Controls",
        price: "$35.00",
        description: "Critical safety components for reliable high and low voltage circuit protection.",
        large_description:
            <>
                <p>Fuses play a major role in industrial or commercial facilities by providing reliable, maximum protection to power systems. Their physical size or rejection features prevent replacing a fuse with one from another fuse class. This helps ensure the correct replacement fuse is always installed, and the voltage and interrupting ratings remain the same.</p>
                <p>Our reputable brand partners include ABB, Eaton Bussmann, Fuji Electric, Schneider Electric, and more.</p>
            </>,
        certification: "https://via.placeholder.com/100x100?text=NIST+Cert",
        images: {
            main: "/Images/products/electrical-and-controls/11.png",
            thumbnails: [
                "/Images/products/electrical-and-controls/11.png",
                "/Images/products/electrical-and-controls/11.png",
                "/Images/products/electrical-and-controls/11.png"
            ]
        }
    },
    {
        id: 21,
        name: "Distribution Boards",
        type: "Electrical-&-Controls",
        price: "$35.00",
        description: "Central hub for safe power distribution and circuit protection.",
        large_description:
            <>
                <p>Distribution boards are a component of an electricity supply system that divides an electrical power feed into subsidiary circuits while providing a protective fuse or circuit breaker for each circuit in a common enclosure.</p>
                <p>Our reputable brand partners include ABB, Schneider Electric, and more.</p>
            </>,
        certification: "https://via.placeholder.com/100x100?text=NIST+Cert",
        images: {
            main: "/Images/products/electrical-and-controls/12.png",
            thumbnails: [
                "/Images/products/electrical-and-controls/12.png",
                "/Images/products/electrical-and-controls/12.png",
                "/Images/products/electrical-and-controls/12.png"
            ]
        }
    },

    // --- 3. Personal-Safety ---
    {
        id: 22,
        name: "Head Protection",
        type: "Personal-Safety",
        price: "$20.00",
        description: "Certified headwear for impact defense and electrical safety.",
        large_description:
            <>
                <p>Protect your team from falling hazards & electrical risks — explore certified hard hats and accessories.</p>
                <p>Head protection is required to protect the head from falling objects and electrical shock. Protection must be worn when working under other employees, when operations are being conducted overhead of your work area, or when working with electrical connectors that may come into contact with the head.</p>
            </>,
        certification: "https://via.placeholder.com/100x100?text=ANSI+Z89",
        images: {
            main: "/Images/products/personal-safety/1.png",
            thumbnails: [
                "/Images/products/personal-safety/1.png",
                "/Images/products/personal-safety/1.png",
                "/Images/products/personal-safety/1.png"
            ]
        }
    },
    {
        id: 23,
        name: "Eye Protection",
        type: "Personal-Safety",
        price: "$20.00",
        description: "Adjustable, ergonomic eyewear to prevent chemical, particle, and radiation injuries.",
        large_description:
            <>
                <p>Eye injuries are common in the workplace and can be prevented if protections are in place. Some common eye injuries are from chemicals, small objects/particles, or radiation around that can cut or scrape the eye.</p>
                <p>Hence, when it comes to eye protection, the right fit makes all the difference. Good eyewear has features that can adjust lens angle. A soft nose bridge is designed to help to accommodate tall cheekbone structure and low nose bridge height.</p>
                <p>Protective eyewear works best when you know how to use it properly. Combined with machine guards, screened or divided workstations, and other engineering controls, using the correct protective eyewear can help keep you safe from any type of eye hazard.</p>
            </>,
        certification: "https://via.placeholder.com/100x100?text=ANSI+Z89",
        images: {
            main: "/Images/products/personal-safety/2.png",
            thumbnails: [
                "/Images/products/personal-safety/2.png",
                "/Images/products/personal-safety/2.png",
                "/Images/products/personal-safety/2.png"
            ]
        }
    },
    {
        id: 24,
        name: "Face Protection",
        type: "Personal-Safety",
        price: "$20.00",
        description: "Customizable full-face shielding against high-impact debris and sparks.",
        large_description:
            <>
                <p>Face protection comes from either face shields or headgears that provide head and face protection in working environments with sparks, chips, and debris.</p>
                <p>This safety system includes ratchet headgear and a polycarbonate face shield. An adjustable thirteen-position ratchet suspension and five-position crown strap offer customized settings for individual users. The clear, molded Faceshield provides unrestricted visibility and high impact protection.</p>
                <p>Workers performing tasks in which flying sparks or particles are present should wear protection to shield their face and head. Industries in which this is typically true include metalworking, utilities, and woodworking. Because the shield does not fully enclose the face, protective eyewear should also be worn to safeguard eyes.</p>
            </>,
        certification: "https://via.placeholder.com/100x100?text=ANSI+Z89",
        images: {
            main: "/Images/products/personal-safety/3.png",
            thumbnails: [
                "/Images/products/personal-safety/3.png",
                "/Images/products/personal-safety/3.png",
                "/Images/products/personal-safety/3.png"
            ]
        }
    },
    {
        id: 25,
        name: "Hearing Protection",
        type: "Personal-Safety",
        price: "$20.00",
        description: "Comprehensive solutions to prevent occupational hearing loss and meet regulations.",
        large_description:
            <>
                <p>Millions of workers are exposed to hearing hazards every year, and even though OSHA regulations and NIOSH recommendations in the U.S. require protection, occupational hearing loss is still the number one reported worker illness in manufacturing.</p>
                <p>You can advance your hearing conservation program with a customized and comprehensive approach to the hearing protection challenge. Implementing a solution that really makes a difference begins with an understanding of the hazards, the regulations, and the factors that impact protection.</p>
            </>,
        certification: "https://via.placeholder.com/100x100?text=ANSI+Z89",
        images: {
            main: "/Images/products/personal-safety/4.png",
            thumbnails: [
                "/Images/products/personal-safety/4.png",
                "/Images/products/personal-safety/4.png",
                "/Images/products/personal-safety/4.png"
            ]
        }
    },
    {
        id: 26,
        name: "Respirator Protection",
        type: "Personal-Safety",
        price: "$20.00",
        description: "Comprehensive respiratory gear and accredited fit-testing for hazardous environments.",
        large_description:
            <>
                <p>Respiratory protection is essential when it comes to protecting the health of the workers from the harmful effects of gases, vapors, and particulate hazards found throughout many working environments.</p>
                <p>We offer a wide range of full face and half face reusable respirators, disposable respirators, powered air purifying respirators, and more. Contact us now to check for stock availability.</p>            </>,
        certification: "https://via.placeholder.com/100x100?text=ANSI+Z89",
        images: {
            main: "/Images/products/personal-safety/5.png",
            thumbnails: [
                "/Images/products/personal-safety/5.png",
                "/Images/products/personal-safety/5.png",
                "/Images/products/personal-safety/5.png"
            ]
        }
    },
    {
        id: 27,
        name: "Fall Protection",
        type: "Personal-Safety",
        price: "$20.00",
        description: "Comprehensive height-safety systems to prevent falls and workplace fatalities.",
        large_description:
            <>
                <p>Falls are among the most common causes of serious work related injuries and deaths. Employers must set up the work place to prevent employees from falling off of overhead platforms, elevated work stations or into holes in the floor and walls.</p>
            </>,
        certification: "https://via.placeholder.com/100x100?text=ANSI+Z89",
        images: {
            main: "/Images/products/personal-safety/6.png",
            thumbnails: [
                "/Images/products/personal-safety/6.png",
                "/Images/products/personal-safety/6.png",
                "/Images/products/personal-safety/6.png"
            ]
        }
    },
    {
        id: 28,
        name: "Foot Protection",
        type: "Personal-Safety",
        price: "$20.00",
        description: "Specialized safety footwear for impact, chemical, and electrical protection.",
        large_description:
            <>
                <p>Potential hazards which may lead to foot and leg injuries include falling or rolling objects, crushing or penetrating materials, hot, corrosive or poisonous substances, electrical hazards, static electricity, or slippery surfaces.</p>
                <p>Whether you are working in the oil and gas, marine and offshore, construction, mining, manufacturing and industrial, automotive, aerospace, logistics, military, or agriculture sectors, we have a boot for you.</p>
            </>,
        certification: "https://via.placeholder.com/100x100?text=ANSI+Z89",
        images: {
            main: "/Images/products/personal-safety/7.png",
            thumbnails: [
                "/Images/products/personal-safety/7.png",
                "/Images/products/personal-safety/7.png",
                "/Images/products/personal-safety/7.png"
            ]
        }
    },

    // --- 4. EV-Chargers ---
    {
        id: 29,
        name: "EV Chargers",
        type: "EV-Chargers",
        price: "$25.00",
        description: "LTA-approved EV charging infrastructure for smart, sustainable mobility.",
        large_description:
            <>
                <p>As a leader in EV charging solutions, we ensure that all our EV chargers have obtained the Letter of No Objection (LNO) and type approval from the Land Transport Authority (LTA), adhering to stringent regulatory standards and guaranteeing reliability.</p>
                <p>By partnering with ABB, Schneider, and other leading EV charger brands in Singapore, we offer a comprehensive range of EV charging solutions, from compact AC wallboxes to high-performance DC fast chargers. Charger Management Software is also provided to enhance the charging experience for EV drivers. Our infrastructure deployment aligns with the needs of the next generation of smarter mobility.</p>
            </>,
        certification: "https://via.placeholder.com/100x100?text=RoHS",
        images: {
            main: "/Images/products/ev-chargers/1.png",
            thumbnails: [
                "/Images/products/ev-chargers/1.png",
                "/Images/products/ev-chargers/1.png",
                "/Images/products/ev-chargers/1.png"
            ]
        }
    },

    // --- 5. Processing-Equipment ---
    {
        id: 30,
        name: "Haulmax Automatic Bag Slitting Machine",
        type: "Processing-Equipment",
        price: "$35.00",
        description: "High-speed, dust-free automation for efficient bulk bag unloading.",
        large_description:
            <>

                <ul>
                    <li>Safe & Clean – Dust-free unloading protects operators and workplace.</li>
                    <li>Effortless Operation – Handles all bag types with ease.</li>
                    <li>Durable Design – Heavy-duty cutter and components built to last.</li>
                    <li>Reliable Performance – Smooth operation with minimal downtime.</li>
                    <li>Smart Integration – Complete system with conveyor, dust collector & compactor.</li>
                </ul>
            </>,
        certification: "https://via.placeholder.com/100x100?text=NIST+Cert",
        images: {
            main: "/Images/products/processing-equipments/1.png",
            thumbnails: [
                "/Images/products/processing-equipments/1.png",
                "/Images/products/processing-equipments/1.png",
                "/Images/products/processing-equipments/1.png"
            ]
        }
    },
    {
        id: 31,
        name: "Haulmax Jumbo Bag Unloader",
        type: "Processing-Equipment",
        price: "$35.00",
        description: "Heavy-duty, dust-free system for safe and efficient bulk bag discharge.",
        large_description:
            <>

                <ul>
                    <li>Effortless Unloading – Engineered for the seamless discharge of jumbo bags.</li>
                    <li>Operator Safety – Equipped with built-in features that reduce manual handling risks.</li>
                    <li>Dust-Free Operation – Integrated dust control systems maintain a clean working environment.</li>
                    <li>Versatile Design – Capable of managing a diverse array of bulk materials.</li>
                    <li>Reliable & Durable – Constructed with heavy-duty materials for long-lasting performance.</li>
                </ul>
            </>,
        certification: "https://via.placeholder.com/100x100?text=NIST+Cert",
        images: {
            main: "/Images/products/processing-equipments/2.png",
            thumbnails: [
                "/Images/products/processing-equipments/2.png",
                "/Images/products/processing-equipments/2.png",
                "/Images/products/processing-equipments/2.png"
            ]
        }
    },
    {
        id: 32,
        name: "Tipping Machine With Sifter",
        type: "Processing-Equipment",
        price: "$35.00",
        description: "Hygienic, dust-free bag tipping with integrated sifting and magnetic separation.",
        large_description:
            <>

                <ul>
                    <li>Dual Functionality – Combines dust-free bag tipping with in-line sifting.</li>
                    <li>Safe & Ergonomic – Operator-friendly design minimizes strain.</li>
                    <li>Dust Control – Built-in de-dusting ensures a clean work environment.</li>
                    <li>Quality Assurance – Integrated sifter removes lumps and foreign particles.</li>
                    <li>Reliable & Versatile – Suitable for food, pharma, chemical, and industrial applications.</li>
                    <li>Bag Dump Station with Magnet</li>
                </ul>
            </>,
        certification: "https://via.placeholder.com/100x100?text=NIST+Cert",
        images: {
            main: "/Images/products/processing-equipments/3.png",
            thumbnails: [
                "/Images/products/processing-equipments/3.png",
                "/Images/products/processing-equipments/3.png",
                "/Images/products/processing-equipments/3.png"
            ]
        }
    },
    {
        id: 33,
        name: "Haulmax Cone Mill",
        type: "Processing-Equipment",
        price: "$35.00",
        description: "Gentle, low-heat particle size reduction for uniform product quality.",
        large_description:
            <>

                <ul>
                    <li>Consistent Results – Delivers uniform particle size for better product quality.</li>
                    <li>Gentle & Efficient – Reduces size without damaging heat-sensitive materials.</li>
                    <li>Easy to Use – Quick screen change and simple cleaning save time.</li>
                    <li>Durable & Hygienic – Stainless steel design built for long life and safe operation.</li>
                    <li>Versatile – Perfect for food, pharma, chemical, and specialty applications.</li>
                </ul>
            </>,
        certification: "https://via.placeholder.com/100x100?text=NIST+Cert",
        images: {
            main: "/Images/products/processing-equipments/4.png",
            thumbnails: [
                "/Images/products/processing-equipments/4.png",
                "/Images/products/processing-equipments/4.png",
                "/Images/products/processing-equipments/4.png"
            ]
        }
    },
    {
        id: 34,
        name: "Haulmax Hammer Mill",
        type: "Processing-Equipment",
        price: "$35.00",
        description: "High-impact pulverization for heavy-duty size reduction of tough raw materials.",
        large_description:
            <>

                <ul>
                    <li>Robust Performance: Heavy-duty build for tough raw materials.</li>
                    <li>Flexible Output: Multiple screen sizes for customized particle size.</li>
                    <li>Optimized Efficiency: Balanced rotor reduces energy use and vibration.</li>
                    <li>Long Service Life: Replaceable wear parts minimize downtime.</li>
                    <li>Cleaner Operation: Compatible with dust extraction for hygiene and safety.</li>
                </ul>
            </>,
        certification: "https://via.placeholder.com/100x100?text=NIST+Cert",
        images: {
            main: "/Images/products/processing-equipments/5.png",
            thumbnails: [
                "/Images/products/processing-equipments/5.png",
                "/Images/products/processing-equipments/5.png",
                "/Images/products/processing-equipments/5.png"
            ]
        }
    },

];